var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"science-technology-are-digital"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"data"},[_vm._v(_vm._s(_vm.data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }